import React, { useEffect, useState, useRef } from "react";

import { api } from "../../services/api";

import axios from "axios"

import { FaSearch } from 'react-icons/fa'
import {
  CardGroup,
  SeachInput,
  ImgSearch,
  TextSearch,
  InputSearch,
  BtnSearch,
  HeroContent,
  Container,
  MainTitle,
  MainRegion
} from "./HomeElements";

import { AutoCompleteComponent } from '@syncfusion/ej2-react-dropdowns';
import Card from "../../components/Card";
import SearchedCity from "../../components/SearchedCity";
import LineChartMain from "../../components/LineChartMain";
import BrazilMap from "../../components/BrazilMap";

type mapDataType = {
  value: Number | null | undefined;
  index: Number;
  name: String;
}

type mainDataType = {
  total_dose1: number;
  total_dose2: number;
  total_dose3: number;
  total_unicas: number;
  vacinados_1dose: number;
  nao_vacinados_1dose: number;
  vacinados_2dose: number;
  nao_vacinados_2dose: number;
  vacinados_3dose: number;
  nao_vacinados_3dose: number;
  vacinados_completamente: number;
  nao_vacinados_completamente: number;
  vacinados_1dose_maior_5: number;
  nao_vacinados_1dose_maior_5: number;
  vacinados_2dose_maior_5: number;
  nao_vacinados_2dose_maior_5: number;
  vacinados_3dose_maior_5: number;
  nao_vacinados_3dose_maior_5: number;
  vacinados_completamente_maior_5: number;
  nao_vacinados_completamente_maior_5: number;
  vacinados_1dose_maior_10: number;
  nao_vacinados_1dose_maior_10: number;
  vacinados_2dose_maior_10: number;
  nao_vacinados_2dose_maior_10: number;
  vacinados_3dose_maior_10: number;
  nao_vacinados_3dose_maior_10: number;
  vacinados_completamente_maior_10: number;
  nao_vacinados_completamente_maior_10: number;
  vacinados_1dose_maior_15: number;
  nao_vacinados_1dose_maior_15: number;
  vacinados_2dose_maior_15: number;
  nao_vacinados_2dose_maior_15: number;
  vacinados_3dose_maior_15: number;
  nao_vacinados_3dose_maior_15: number;
  vacinados_completamente_maior_15: number;
  nao_vacinados_completamente_maior_15: number;
  array_total_dose1: [number];
  array_total_dose2: [number];
  array_total_dose3: [number];
  array_total_unicas: [number];
  array_total_vacinados_completamente: [number];
  array_recebidas: [number];
  array_aplicadas: [number];
  array_pop_vacinada: [number];
  array_pop_vacinada_maior_5: [number];
  array_pop_vacinada_maior_10: [number];
  array_pop_vacinada_maior_15: [number];
  data_atualizacao: string;
  legendaMeses: [string];
}

type searchedCityProps = {
  estado: string,
  municipio: string,
  array_total_dose1: [number];
  array_total_dose2: [number];
  array_total_dose3: [number];
  array_total_unicas: [number];
  array_total_vacinados_completamente: [number];
  array_recebidas: [number];
  array_aplicadas: [number];
  array_pop_vacinada: [number];
  array_pop_vacinada_dose1: [number];
  array_pop_vacinada_dose2: [number];
  array_pop_vacinada_dose3: [number];
  array_pop_vacinada_maior_5: [number];
  array_pop_vacinada_maior_10: [number];
  array_pop_vacinada_maior_15: [number];
  data_atualizacao: string,
  legendaMeses: [number];
}


export default function Home() {
  const [mapData, setMapData] = useState<mapDataType>();
  const [mainData, setMainData] = useState<mainDataType>();
  const [filter, setFilter] = useState<string>("");
  const [citiesNames, setCitiesNames] = useState<string[]>([]);
  const [cityData, setCityData] = useState<searchedCityProps>();

  const messagesEndRef = useRef(null)

  const scrollToBottom = () => {
    //@ts-ignore
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" })
  }

  //recebe as props do estado específico
  function handleClickMap(props: mapDataType) {
    setMapData(props);
    //corrigir na API quando puxar pelo nome completo
    api.get(`estado/${props.name === "São Paulo" ? "SP" : "MG"}/overview`).then((res) => {
      setMainData(res.data);
    })
  }

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newText = event.target.value;
    setFilter(newText);
    scrollToBottom();
  }

  const handleClickButton = () => {
    GenerateCity()
  }

  const GenerateCity = () => {
    if (filter !== "") {
      const barData = [
        { name: "1a dose", data: cityData?.array_total_dose1 },
        { name: "2a dose", data: cityData?.array_total_dose2 },
        { name: "3a dose", data: cityData?.array_total_dose3 }
      ]
      return (
        <>
          <div ref={messagesEndRef} />
          <SearchedCity
            //a porcentagem precisa ser modificada na API antes da utilização da mesma.
            name={filter}
            percentageValue1={percentageConverter(cityData?.array_pop_vacinada[cityData?.array_pop_vacinada_dose1.length - 1])}
            absoluteValue1={numberConverter(cityData?.array_total_dose1[cityData.array_total_dose1.length - 1])}
            percentageValue2={percentageConverter(cityData?.array_pop_vacinada_dose2[cityData?.array_pop_vacinada_dose2.length - 1])}
            absoluteValue2={numberConverter(cityData?.array_total_dose2[cityData.array_total_dose2.length - 1])}
            percentageValue3={percentageConverter(cityData?.array_pop_vacinada_dose3[cityData?.array_pop_vacinada_dose3.length - 1])}
            absoluteValue3={numberConverter(cityData?.array_total_dose3[cityData.array_total_dose3.length - 1])}
            lineChartData={cityData?.array_total_vacinados_completamente}
            //@ts-ignore
            barChartData={barData}
          />
        </>)
    }
  }

  const numberConverter = (props: number | undefined) => {
    return String(props === undefined ? "temp" : props.toLocaleString('pt-BR'))
  }

  const percentageConverter = (props: number | undefined) => {
    return `${String(Math.round(props === undefined ? 0 : props))}%`
  }

  useEffect(() => {
    let arr: string[] = [];
    const reqSP = api.get("doses/SP/cities");
    const reqMG = api.get("doses/MG/cities")
    axios.all([reqSP, reqMG]).then(axios.spread((...responses) => {
      const reqSP = responses[0];
      const reqMG = responses[1];
      reqSP.data.map((city: any) => {
        arr.push(city.municipio);
      })
      reqMG.data.map((city: any) => {
        arr.push(city.municipio);
      })
    })).then(() => { setCitiesNames(arr) })
  }, [])

  useEffect(() => {
    api.get<searchedCityProps>(`https://vacinacao-api.herokuapp.com/api/cidade/${filter}/overview`).then((res) => {
      setCityData(res.data);
    })
  }, [filter])

  return (
    <Container>
      <SeachInput>
        <ImgSearch src="./images/placeholder.png" alt="" />
        <TextSearch>Como está sua cidade?</TextSearch>
        <InputSearch>
          <AutoCompleteComponent onChange={handleInputChange} placeholder="Insira o nome da Cidade"
            fields={{ value: 'Insira o nome da Cidade' }} dataSource={citiesNames}></AutoCompleteComponent>
        </InputSearch>
        <BtnSearch onClick={handleClickButton}><FaSearch /></BtnSearch>
      </SeachInput>
      <MainTitle><h1>Região Selecionada no Momento: <MainRegion>{mapData?.name}</MainRegion></h1></MainTitle>
      <HeroContent>
        <BrazilMap
          seriesName="Vacinação Valor Absoluto"
          title="Mapa do Brasil Vacinação Absolutos"
          onSelectMap={handleClickMap}
        />
        <LineChartMain
          title={mapData === null || mapData?.name === undefined ? "Quantidade de Vacinados Brasil" : "Quantidade de Vacinados " + mapData?.name}
          yTitle="Vacinados em Valor Absoluto"
          seriesName={mapData === null || mapData?.name === undefined ? "Vacinados Brasil" : "Vacinados " + mapData?.name}
          intervalPoint={31 * 24 * 3600 * 1000}
          startPoint={Date.UTC(2021, 0, 1)}
          //@ts-ignore corrigir isso depois
          dataValues={mainData?.array_total_dose1}
        />
      </HeroContent>
      <CardGroup>
        <Card
          title="1&#170; dose da vacina"
          percentageValue={percentageConverter(mainData?.vacinados_1dose)}
          absoluteValue={numberConverter(mainData?.total_dose1)}
        />
        <Card
          title="2&#170; dose da vacina"
          percentageValue={percentageConverter(mainData?.vacinados_2dose)}
          absoluteValue={numberConverter(mainData?.total_dose2)} />
        <Card
          title="Dose de reforço"
          percentageValue={percentageConverter(mainData?.vacinados_3dose)}
          absoluteValue={numberConverter(mainData?.total_dose3)} />
      </CardGroup>

      {GenerateCity()}
    </Container >
  )
}